var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "19px",
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AMEX") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Click-to-Pay-Styles-for-UI-Display",
    transform: "translate(-3890.000000, -619.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "button_dark_v3.1_178x32",
    transform: "translate(3776.000000, 612.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "v4_mark_light_S_15px",
    transform: "translate(14.500000, 7.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AMEX",
    transform: "translate(100.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Amex-500x500@1x"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,18 L18,18 L18,15.147828 L15.828444,15.147828 L14.710428,13.911588 L13.58676,15.147828 L6.426972,15.147828 L6.426972,9.386172 L4.116096,9.386172 L6.982488,2.89926 L9.746856,2.89926 L10.733652,5.121576 L10.733652,2.89926 L14.155416,2.89926 L14.749524,4.573872 L15.34752,2.89926 L18,2.89926 L18,0 L0,0 Z M15.884244,3.620664 L14.754384,6.758172 L13.631796,3.620664 L11.480112,3.620664 L11.480112,8.658072 L12.840192,8.658072 L12.840192,5.131872 L14.135616,8.658072 L15.344496,8.658072 L16.639812,5.1246 L16.639812,8.658072 L18,8.658072 L18,3.620664 L15.884244,3.620664 Z M7.486272,3.620664 L5.262516,8.658072 L6.77376,8.658072 L7.191216,7.650576 L9.508356,7.650576 L9.93294,8.658072 L11.480112,8.658072 L9.256608,3.620664 L7.486272,3.620664 Z M8.349804,4.87278 L9.03348,6.520716 L7.666092,6.520716 L8.349804,4.87278 Z M16.222968,9.389052 L14.747796,11.00106 L13.286808,9.389052 L11.480616,9.389052 L13.855356,11.907792 L11.480616,14.426496 L13.236516,14.426496 L14.71896,12.800088 L16.19424,14.426496 L18,14.426496 L15.611328,11.893356 L18,9.389052 L16.222968,9.389052 Z M7.191576,9.389052 L7.191576,14.426496 L11.480508,14.426496 L11.480508,13.260672 L8.566128,13.260672 L8.566128,12.476268 L11.40858,12.476268 L11.40858,11.339172 L8.566128,11.339172 L8.566128,10.554912 L11.480508,10.554912 L11.480508,9.389052 L7.191576,9.389052 Z M16.6167,11.89548 L18,13.367124 L18,10.436112 L16.6167,11.89548 Z",
    id: "500x500",
    fill: "#006FCF"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-export",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.9d3f0db0dfbe28be70aa2434329a9a0b.svg";
export { ForwardRef as ReactComponent };